/*const CymacoQuote = () => import('@/views/custom/cymaco/CymacoQuote')
const CymacoQuoteForm = () => import('@/views/custom/cymaco/CymacoQuoteForm')*/

export default {

    remove: [],
    routes: [],

    /*remove: [
        "business-quote",
        "business-quote-form-new",
        "business-quote-form-view",
        "business-quote-form-remove",
        "business-quote-form",
    ],
    routes: [
        {
            path: '/custom/business/quote/new',
            name: 'custom-cymaco-business-quote-form-new',
            component: CymacoQuoteForm
        }, {
            path: '/custom/business/quote/view/:id',
            name: 'custom-cymaco-business-quote-form-view',
            component: CymacoQuoteForm
        }, {
            path: '/custom/business/quote/remove/:id',
            name: 'custom-cymaco-business-quote-form-remove',
            component: CymacoQuoteForm
        }, {
            path: '/custom/business/quote/:id',
            name: 'custom-cymaco-business-quote-form',
            component: CymacoQuoteForm
        },
        {
            path: '/custom/business/quote',
            name: 'custom-cymaco-business-quote',
            component: CymacoQuote
        }

    ]*/
}
